(function () {
  var roots = document.querySelectorAll('[data-ss-vw]');
  if (!roots.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  Array.prototype.forEach.call(roots, function (root) {
    var rail = root.querySelector('[data-ss-vw-rail]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    if (!rail) return;

    var sectionVisible = false;
    var ratios = new Map();

    // Posters and sources ship as data attributes, so the page downloads no
    // video weight until the shopper is actually near the section.
    function posters() {
      videos.forEach(function (v) {
        if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
      });
    }
    function arm(v) {
      if (v.dataset.armed) return;
      Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
        s.src = s.getAttribute('data-src');
      });
      v.preload = 'auto';
      v.load();
      v.dataset.armed = '1';
    }
    function play(v) {
      arm(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function quiet(v) {
      v.pause();
      v.muted = true;
      v.parentNode.classList.remove('is-loud');
    }

    // One clip plays at a time: the one most in view (a loud clip keeps
    // playing while it is in view). Two or three clips decoding at once made
    // the page stutter on phones.
    function current() {
      var loud = videos.filter(function (v) { return !v.muted && (ratios.get(v) || 0) >= 0.4; })[0];
      if (loud) return loud;
      var best = null, bestRatio = 0.4;
      videos.forEach(function (v) {
        var r = ratios.get(v) || 0;
        if (r >= bestRatio) { best = v; bestRatio = r; }
      });
      return best;
    }
    function update() {
      var pick = sectionVisible && !document.hidden ? current() : null;
      videos.forEach(function (v) {
        if (v === pick) play(v);
        else if (!v.paused) v.pause();
      });
    }

    if (!hasIO) {
      posters();
    } else {
      // Posters arrive a little before the section scrolls in.
      var near = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            posters();
            near.disconnect();
          }
        },
        { rootMargin: '600px 0px' }
      );
      near.observe(root);

      if (!reduce) {
        var inRail = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0);
            });
            update();
          },
          { root: rail, threshold: [0, 0.4, 0.6, 0.8, 1] }
        );
        videos.forEach(function (v) {
          inRail.observe(v);
        });

        var onPage = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              sectionVisible = e.isIntersecting;
            });
            if (!sectionVisible) videos.forEach(quiet);
            update();
          },
          { threshold: 0.1 }
        );
        onPage.observe(root);

        // Nothing plays while the tab is in the background (the cart drawer,
        // another app, the checkout).
        document.addEventListener('visibilitychange', update);
      }
    }

    // Tap a clip to hear it. Only one clip carries sound at a time.
    root.addEventListener('click', function (e) {
      var tile = e.target && e.target.closest ? e.target.closest('.ss-vw__tile') : null;
      if (!tile) return;
      var v = tile.querySelector('video');
      if (!v) return;

      var turningOn = v.muted;
      videos.forEach(function (o) {
        o.muted = true;
        o.parentNode.classList.remove('is-loud');
      });
      if (turningOn) {
        v.muted = false;
        tile.classList.add('is-loud');
        videos.forEach(function (o) { if (o !== v) o.pause(); });
        play(v);
      } else {
        update();
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ss-vw-nav]'), function (btn) {
      btn.addEventListener('click', function () {
        var tile = rail.querySelector('.ss-vw__tile');
        var step = tile ? tile.getBoundingClientRect().width + 10 : 240;
        var dir = btn.getAttribute('data-ss-vw-nav') === 'next' ? 1 : -1;
        rail.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      });
    });
  });
})();